module.exports = __webpack_public_path__ + "js/6.28306cda.worker.js"